
import { Checkbox, Col, Form, Input, InputNumber, Radio, Row, Select } from 'antd';
import React, { useEffect, useState } from 'react';
import globalGetPadding from '../../utils/getPadding';
import { getBorderRadiusValue } from '../../utils/borderRadius';
import { getCheckboxCheckedCss, getCheckboxOptionWrapperStyle } from '../../utils/checkboxOptionStyle';
import { getFormItemLabelNode } from '../../utils/formLabel';
function getFontFamily(fontFamily) {
    switch (fontFamily) {
        case 'MODERN_SANS':
            return '"Helvetica Neue", "Arial Nova", "Nimbus Sans", Arial, sans-serif';
        case 'BOOK_SANS':
            return 'Optima, Candara, "Noto Sans", source-sans-pro, sans-serif';
        case 'ORGANIC_SANS':
            return 'Seravek, "Gill Sans Nova", Ubuntu, Calibri, "DejaVu Sans", source-sans-pro, sans-serif';
        case 'GEOMETRIC_SANS':
            return 'Avenir, "Avenir Next LT Pro", Montserrat, Corbel, "URW Gothic", source-sans-pro, sans-serif';
        case 'HEAVY_SANS':
            return 'Bahnschrift, "DIN Alternate", "Franklin Gothic Medium", "Nimbus Sans Narrow", sans-serif-condensed, sans-serif';
        case 'ROUNDED_SANS':
            return 'ui-rounded, "Hiragino Maru Gothic ProN", Quicksand, Comfortaa, Manjari, "Arial Rounded MT Bold", Calibri, source-sans-pro, sans-serif';
        case 'MODERN_SERIF':
            return 'Charter, "Bitstream Charter", "Sitka Text", Cambria, serif';
        case 'BOOK_SERIF':
            return '"Iowan Old Style", "Palatino Linotype", "URW Palladio L", P052, serif';
        case 'MONOSPACE':
            return '"Nimbus Mono PS", "Courier New", "Cutive Mono", monospace';
        default:
            return undefined;
    }
}

const UnSubFormPropsDefaults = {
    label: '',
    name: '',
    optionGap: 8,
    required: false,
    visible: {
        alwaysShow: true,
        conditions: []
    },
    isFormItem: true
};

export const FormUnSubForm = (_a)=> {
    const rootData = _a.form_data.root;
    const root_formStyle = rootData?.data?.formStyle;
    const root_formMessage = rootData?.data?.messageData;
    const isMobile = _a.formClientWidth <= 480;
    var _b, _c, _d, _e, _f, _bb, _cc, _dd;
    var style = _a.style;
    var wStyle = {
        backgroundColor: (_c = style === null || style === void 0 ? void 0 : style.backgroundColor) !== null && _c !== void 0 ? _c : undefined,
        padding: globalGetPadding(style === null || style === void 0 ? void 0 : style.padding, isMobile),
        borderRadius: getBorderRadiusValue((_f = style === null || style === void 0 ? void 0 : style.borderRadius) !== null && _f !== void 0 ? _f : undefined),
    };
    var labelStyle = {
        color: (_b = style === null || style === void 0 ? void 0 : style.color) !== null && _b !== void 0 ? _b : undefined,
        fontSize: (_d = style === null || style === void 0 ? void 0 : style?.fontSize) !== null && _d !== void 0 ? (isMobile ? _d/1.1 : _d) : undefined,
        fontFamily: getFontFamily(style === null || style === void 0 ? void 0 : style.fontFamily),
        fontWeight: (_e = style === null || style === void 0 ? void 0 : style.fontWeight) !== null && _e !== void 0 ? _e : undefined,
    }
    var optionLabelStyle = {
        color: (_bb = style === null || style === void 0 ? void 0 : style.optionLabelColor) !== null && _bb !== void 0 ? _bb : undefined,
        fontSize: (_cc = style === null || style === void 0 ? void 0 : style?.optionLabelFontSize) !== null && _cc !== void 0 ? (isMobile ? _cc/1.1 : _cc) : undefined,
        fontWeight: (_dd = style === null || style === void 0 ? void 0 : style.optionLabelFontWeight) !== null && _dd !== void 0 ? _dd : undefined,
    }
    // var text = (_g = props === null || props === void 0 ? void 0 : props.text) !== null && _g !== void 0 ? _g : TextPropsDefaults.text;
    // return <div style={wStyle}>
    //     {text}
    // </div>;

    var _g, _h, _i, _j, _k, _l, _m, _n, _o;
    var props = _a.props;
    var label = (_g = props === null || props === void 0 ? void 0 : props.label) !== null && _g !== void 0 ? _g : UnSubFormPropsDefaults.label;
    var required = (_k = props === null || props === void 0 ? void 0 : props.required) !== null && _k !== void 0 ? _k : UnSubFormPropsDefaults.required;
    
    const formStyle = _a.formStyle;
    const item_layout = !formStyle?.layout && root_formStyle?.layout ? root_formStyle?.layout : formStyle?.layout ? 
        formStyle?.layout : '';
    const item_colon = formStyle?.colon === undefined && root_formStyle?.colon !== undefined ? root_formStyle?.colon : formStyle?.colon;
    const inline = (_i = formStyle === null || formStyle === void 0 ? void 0 : formStyle.inline) !== null && _i !== void 0 ? _i : UnSubFormPropsDefaults.inline;
    const optionGap = formStyle?.optionGap !== null && formStyle?.optionGap !== void 0 ? formStyle?.optionGap : UnSubFormPropsDefaults.optionGap;

    const requiredText = props?.requiredText !== null && props?.requiredText !== void 0 ? props?.requiredText : root_formMessage?.required;

    const formItemLabel = getFormItemLabelNode(label, required, labelStyle, item_layout === 'vertical' && item_colon);
    const optionWrapperStyle = getCheckboxOptionWrapperStyle(style, isMobile);
    const optionClassName = 'unsub-option-style-preview';
    return _a.unSubData?.result === true ? null : <div style={wStyle}>
        <style>{getCheckboxCheckedCss(optionClassName, style?.optionCheckedBackgroundColor)}</style>
        <Form.Item
            name={"topics"}
            label={formItemLabel}
            rules={required ? [{ required: true, message: requiredText}] : []}
            valuePropName="checked"
        >
            <Checkbox.Group
                style={{
                    display: 'flex',
                    flexDirection: inline === 'Yes' ? 'row' : 'column',
                    gap: optionGap
                }}
                value={_a.unSubData?.selectTopics}
                onChange={_a.unSubData?.handleOnChange}
            >
                {
                    _a.unSubData?.topics?.map((item, ind)=>{
                        return <div key={ind} style={optionWrapperStyle}>
                            <Checkbox className={optionClassName} value={item.value}>
                                <p
                                    style={optionLabelStyle}
                                >{item.label}</p>
                            </Checkbox>
                        </div>
                    })
                }
            </Checkbox.Group>   
        </Form.Item>
    </div>
}

